import styled from '@emotion/styled'
import { STEP_LAYOUT_SMALL_WIDTH } from '../shared/shared-step-layout.styled'

const StepContent = styled.div<{ hasDedicationPreview?: boolean }>`
  gap: 24px;
  display: flex;
  flex-direction: column;
  background: white;
  margin-bottom: 32px;
  padding: 32px 48px;
  border-radius: ${(props) => (props.hasDedicationPreview ? '0 0 20px 20px' : '20px')};

  @media (max-width: ${STEP_LAYOUT_SMALL_WIDTH}) {
    padding: 32px 24px;
    border-radius: 0;
  }
`

export default StepContent
